import { useEffect } from 'react';
import { imageCache } from '@/utils/admin/imageCache';

/**
 * Sets up a single interval to clear expired image cache entries.
 * Mount this once near the app root.
 */
export const useImageCacheCleanup = () => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      imageCache.clearExpired();
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);
};


